import fonts from "../../../styles/fonts";
import palette from "../../../styles/palette";

export default {
    wrapper: {
        textAlign: "center",
        padding: 20
    } as React.CSSProperties,
    container: {
        display: "inline-block",
        width: "100%",
        maxWidth: 1200
    } as React.CSSProperties,
    toolBar: {
        textAlign: "left",
        marginBottom: 20
    } as React.CSSProperties,
    title: {
        ...fonts.title,
        fontSize: 40,
        color: palette.text.primary,
        marginBottom: 10
    } as React.CSSProperties,
    message: {
        fontSize: 20,
        color: palette.text.secondary,
        fontWeight: 500
    } as React.CSSProperties,
    button: {
        marginRight: 20,
        marginBottom: 10
    } as React.CSSProperties,

};